define("shared/components/shared/wizards/credentials/ig-business-setup", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@ember/object/computed", "@ember/utils", "ember-concurrency", "later/errors/index", "@ember/object"], function (_exports, _component, _templateFactory, _service, _computed, _utils, _emberConcurrency, _index, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35;

  0; //eaimeta@70e063a35619d71f0,"ember-classic-decorator",0,"@ember/service",0,"@ember/object/computed",0,"@ember/component",0,"@ember/utils",0,"ember-concurrency",0,"later/errors/index",0,"@ember/object",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showCredentialsStatus}}
    <Shared::Credentials::Status
      @beginRefresh={{action "beginRefresh"}}
      @close={{action @close}}
      @completed={{this.completed}}
      @resetState={{action "resetState"}}
      @revokePermissions={{task this.revokePermissions}}
      @source={{@source}}
    />
  {{else if this.showConnection}}
    <Shared::Credentials::Connection
      @close={{action @close}}
      @connectedPage={{this.connectedPage}}
      @facebookUser={{this.facebookUser}}
      @pages={{this.pages}}
      @refreshBusiness={{task this.refreshBusiness}}
      @selectPage={{action "selectPage"}}
      @selectPageNotFound={{action "selectPageNotFound"}}
    />
  {{else if this.showUnconnectedPages}}
    <Shared::Credentials::UnconnectedPages
      @close={{action @close}}
      @facebookUser={{this.facebookUser}}
      @connectedPage={{this.connectedPage}}
      @pages={{this.pages}}
      @selectPage={{action "selectPage"}}
      @selectPageNotFound={{action "selectPageNotFound"}}
      @showHelpDropdown={{false}}
      @checkScope={{this.checkScope}}
    />
  {{else if this.showFindNewPage}}
    <Shared::Credentials::FindNewPage
      @close={{action @close}}
      @facebookUser={{this.facebookUser}}
      @revokePermissions={{task this.revokePermissions}}
    />
  {{else if this.showGrantNewPermissions}}
    <Shared::Credentials::GrantNewPermissions
      @close={{action @close}}
      @refreshBusiness={{task this.refreshBusiness}}
    />
  {{else if this.showDocsForNewPage}}
    <Shared::Credentials::DocsForNewPage
      @close={{action @close}}
      @instagramSettingsLink={{this.instagramSettingsLink}}
      @revokePermissions={{task this.revokePermissions}}
    />
  {{else if this.showMissingPermissions}}
    <Shared::Credentials::MissingPermissions
      @close={{action @close}}
      @facebookUser={{this.facebookUser}}
      @missingScopes={{this.missingScopes}}
      @revokePermissions={{task this.revokePermissions}}
    />
  {{else if this.showConnectionFailure}}
    <Shared::Credentials::ConnectionFailure
      @dismissContactUs={{action "dismissContactUs"}}
      @source={{@source}}
      @close={{action @close}}
    />
  {{/if}}
  
  */
  {
    "id": "DPYku30g",
    "block": "[[[41,[30,0,[\"showCredentialsStatus\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@beginRefresh\",\"@close\",\"@completed\",\"@resetState\",\"@revokePermissions\",\"@source\"],[[28,[37,2],[[30,0],\"beginRefresh\"],null],[28,[37,2],[[30,0],[30,1]],null],[30,0,[\"completed\"]],[28,[37,2],[[30,0],\"resetState\"],null],[28,[37,3],[[30,0,[\"revokePermissions\"]]],null],[30,2]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showConnection\"]],[[[1,\"  \"],[8,[39,4],null,[[\"@close\",\"@connectedPage\",\"@facebookUser\",\"@pages\",\"@refreshBusiness\",\"@selectPage\",\"@selectPageNotFound\"],[[28,[37,2],[[30,0],[30,1]],null],[30,0,[\"connectedPage\"]],[30,0,[\"facebookUser\"]],[30,0,[\"pages\"]],[28,[37,3],[[30,0,[\"refreshBusiness\"]]],null],[28,[37,2],[[30,0],\"selectPage\"],null],[28,[37,2],[[30,0],\"selectPageNotFound\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showUnconnectedPages\"]],[[[1,\"  \"],[8,[39,5],null,[[\"@close\",\"@facebookUser\",\"@connectedPage\",\"@pages\",\"@selectPage\",\"@selectPageNotFound\",\"@showHelpDropdown\",\"@checkScope\"],[[28,[37,2],[[30,0],[30,1]],null],[30,0,[\"facebookUser\"]],[30,0,[\"connectedPage\"]],[30,0,[\"pages\"]],[28,[37,2],[[30,0],\"selectPage\"],null],[28,[37,2],[[30,0],\"selectPageNotFound\"],null],false,[30,0,[\"checkScope\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showFindNewPage\"]],[[[1,\"  \"],[8,[39,6],null,[[\"@close\",\"@facebookUser\",\"@revokePermissions\"],[[28,[37,2],[[30,0],[30,1]],null],[30,0,[\"facebookUser\"]],[28,[37,3],[[30,0,[\"revokePermissions\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showGrantNewPermissions\"]],[[[1,\"  \"],[8,[39,7],null,[[\"@close\",\"@refreshBusiness\"],[[28,[37,2],[[30,0],[30,1]],null],[28,[37,3],[[30,0,[\"refreshBusiness\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showDocsForNewPage\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@close\",\"@instagramSettingsLink\",\"@revokePermissions\"],[[28,[37,2],[[30,0],[30,1]],null],[30,0,[\"instagramSettingsLink\"]],[28,[37,3],[[30,0,[\"revokePermissions\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showMissingPermissions\"]],[[[1,\"  \"],[8,[39,9],null,[[\"@close\",\"@facebookUser\",\"@missingScopes\",\"@revokePermissions\"],[[28,[37,2],[[30,0],[30,1]],null],[30,0,[\"facebookUser\"]],[30,0,[\"missingScopes\"]],[28,[37,3],[[30,0,[\"revokePermissions\"]]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showConnectionFailure\"]],[[[1,\"  \"],[8,[39,10],null,[[\"@dismissContactUs\",\"@source\",\"@close\"],[[28,[37,2],[[30,0],\"dismissContactUs\"],null],[30,2],[28,[37,2],[[30,0],[30,1]],null]]],null],[1,\"\\n\"]],[]],null]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]]],[\"@close\",\"@source\"],false,[\"if\",\"shared/credentials/status\",\"action\",\"task\",\"shared/credentials/connection\",\"shared/credentials/unconnected-pages\",\"shared/credentials/find-new-page\",\"shared/credentials/grant-new-permissions\",\"shared/credentials/docs-for-new-page\",\"shared/credentials/missing-permissions\",\"shared/credentials/connection-failure\"]]",
    "moduleName": "shared/components/shared/wizards/credentials/ig-business-setup.hbs",
    "isStrictMode": false
  });

  let IgBusinessSetup = (_dec = (0, _service.inject)('social/facebook-graph'), _dec2 = (0, _service.inject)('social/facebook-auth'), _dec3 = (0, _service.inject)('social/instagram-business'), _dec4 = (0, _computed.alias)('state.currentModal'), _dec5 = (0, _computed.alias)('credentials.state'), _dec6 = (0, _computed.equal)('activePageId', 0), _dec7 = (0, _computed.equal)('currentModal', 'currentConnection'), _dec8 = (0, _computed.equal)('currentModal', 'connectionFailure'), _dec9 = (0, _computed.equal)('currentModal', 'credentialsStatus'), _dec10 = (0, _computed.equal)('currentModal', 'docsForNewPage'), _dec11 = (0, _computed.equal)('currentModal', 'findNewPage'), _dec12 = (0, _computed.equal)('currentModal', 'grantNewPermissions'), _dec13 = (0, _computed.equal)('currentModal', 'unconnectedPages'), _dec14 = (0, _computed.equal)('currentModal', 'missingPermissions'), _dec15 = (0, _computed.reads)('state.activePage.id'), _dec16 = (0, _computed.reads)('state.activePage.name'), _dec17 = (0, _computed.reads)('socialProfile.businessAccountId'), _dec18 = (0, _computed.reads)('socialProfile.hasUnconnectedProfessional'), _dec19 = (0, _computed.reads)('socialProfile.facebookPageId'), _dec20 = (0, _computed.reads)('auth.currentGroup'), _dec21 = (0, _computed.reads)('socialProfile.needsProfessionalTokenRefresh'), _dec22 = (0, _computed.reads)('socialProfile.instagramBusinessTokenExpiring'), _dec23 = (0, _computed.reads)('state.nameOfPage'), _dec24 = (0, _computed.reads)('socialProfile.nickname'), _dec25 = (0, _computed.reads)('auth.currentAccount.owner'), _dec26 = (0, _computed.equal)('activePageName', 'nameOfPage'), _dec27 = (0, _object.computed)('isDisconnected', 'isExpiring'), _dec28 = (0, _object.computed)('activePageEqualsGivenPage', 'nameOfPage', 'activePageId'), _dec29 = (0, _emberConcurrency.task)(function* (allowRevoke) {
    try {
      yield this.facebookAuth.authenticateFacebook(this.instagramBusiness.potentialScopes);
      const response = yield this.instagramBusiness.refreshBusiness.perform(this.socialProfile);
      const allScopes = yield this.checkAllScopes.perform();
      const isMissingScopes = Object.entries(allScopes).some(_ref2 => {
        let [key, isValid] = _ref2;

        if (key === 'instagram_content_publish' && this.socialProfile.isCreator) {
          return false;
        }

        return !isValid;
      });

      if (isMissingScopes) {
        throw new _index.CredentialsMissingPermissionsError().withAdditionalData({
          allScopes
        });
      }

      if (response) {
        this.set('currentModal', 'credentialsStatus');
        this.segment.track('connected-successfully-creds-wiz', {
          social_profile: this.socialProfile,
          page: this.credentials.source
        });
        return this.set('completed', true);
      }
    } catch (error) {
      if (error instanceof _index.CredentialsMissingPermissionsError) {
        const {
          allScopes
        } = error.additionalData ? error.additionalData.shift() : {
          allScopes: null
        };
        return error.resolve.call(this, allScopes);
      }

      this.errors.log(error);

      if (!allowRevoke) {
        this.auth.setSocialProfile(this.socialProfile);
        this.set('currentModal', 'connectionFailure');
      } else {
        this.set('state.hasRevoked', true);
        this.set('currentModal', 'missingPermissions');
      }
    }
  }), _dec30 = (0, _emberConcurrency.task)(function* () {
    var _page;

    const response = yield this.socialProfile.facebookTokenDebug({
      token: this.socialProfile.businessAccountToken
    });
    const {
      granular_scopes
    } = response;

    const checkScope = (scope, id) => {
      const scopeValue = granular_scopes.find(item => item.scope === scope);
      return scopeValue && (!scopeValue.target_ids || scopeValue.target_ids.includes(id));
    };

    const instagram_basic = checkScope('instagram_basic', this.businessAccountId);
    const instagram_content_publish = checkScope('instagram_content_publish', this.businessAccountId); // use the actual connected page id by default

    const pageId = this.connectedPageId || this.activePageId;
    let page;

    try {
      page = yield this.facebook.fetchPage.perform(this.socialProfile.businessAccountToken, pageId);
    } catch (error) {
      this.errors.log(error, {}, 'info');
    }

    let business_management = true;

    if ((_page = page) !== null && _page !== void 0 && _page.business) {
      business_management = checkScope('business_management', page.business.id);
    }

    const pages_read_user_content = checkScope('pages_read_user_content', pageId);
    const pages_manage_posts = checkScope('pages_manage_posts', pageId);
    const result = {
      business_management,
      instagram_basic,
      instagram_content_publish,
      pages_read_user_content,
      pages_manage_posts
    };
    console.log(result);
    return result;
  }), _dec31 = (0, _emberConcurrency.task)(function* () {
    try {
      yield this.instagramBusiness.revokePermissions.perform(this.socialProfile);
      const eventName = this.missingPage ? 'revoked-and-reauth-missing-page-creds-wiz' : 'revoked-and-reauth-missing-permissions-creds-wiz';
      this.segment.track(eventName, {
        social_profile: this.socialProfile,
        page: this.source
      });
    } catch (error) {
      this.errors.log(error);
    } finally {
      this.set('state.currentModal', 'grantNewPermissions');
    }
  }), (_class = class IgBusinessSetup extends _component.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "credentials", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "facebook", _descriptor5, this);

      _initializerDefineProperty(this, "facebookAuth", _descriptor6, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor7, this);

      _initializerDefineProperty(this, "intl", _descriptor8, this);

      _initializerDefineProperty(this, "segment", _descriptor9, this);

      _defineProperty(this, "completed", null);

      _initializerDefineProperty(this, "currentModal", _descriptor10, this);

      _initializerDefineProperty(this, "state", _descriptor11, this);

      _initializerDefineProperty(this, "missingPage", _descriptor12, this);

      _initializerDefineProperty(this, "showConnection", _descriptor13, this);

      _initializerDefineProperty(this, "showConnectionFailure", _descriptor14, this);

      _initializerDefineProperty(this, "showCredentialsStatus", _descriptor15, this);

      _initializerDefineProperty(this, "showDocsForNewPage", _descriptor16, this);

      _initializerDefineProperty(this, "showFindNewPage", _descriptor17, this);

      _initializerDefineProperty(this, "showGrantNewPermissions", _descriptor18, this);

      _initializerDefineProperty(this, "showUnconnectedPages", _descriptor19, this);

      _initializerDefineProperty(this, "showMissingPermissions", _descriptor20, this);

      _initializerDefineProperty(this, "activePageId", _descriptor21, this);

      _initializerDefineProperty(this, "activePageName", _descriptor22, this);

      _initializerDefineProperty(this, "businessAccountId", _descriptor23, this);

      _initializerDefineProperty(this, "hasUnconnectedProfessional", _descriptor24, this);

      _initializerDefineProperty(this, "connectedPageId", _descriptor25, this);

      _initializerDefineProperty(this, "currentGroup", _descriptor26, this);

      _initializerDefineProperty(this, "isDisconnected", _descriptor27, this);

      _initializerDefineProperty(this, "isExpiring", _descriptor28, this);

      _initializerDefineProperty(this, "nameOfPage", _descriptor29, this);

      _initializerDefineProperty(this, "nickname", _descriptor30, this);

      _initializerDefineProperty(this, "owner", _descriptor31, this);

      _initializerDefineProperty(this, "activePageEqualsGivenPage", _descriptor32, this);

      _initializerDefineProperty(this, "refreshBusiness", _descriptor33, this);

      _initializerDefineProperty(this, "checkAllScopes", _descriptor34, this);

      _initializerDefineProperty(this, "revokePermissions", _descriptor35, this);
    }

    init() {
      super.init(...arguments);
      this.credentials.initState(this.socialProfile, this.source);
    }

    get featureStatusCss() {
      if (this.isDisconnected) {
        return 'u--m__r__xs i-warning u--text--danger';
      } else if (this.isExpiring) {
        return 'u--m__r__xs i-danger-1 u--text--warning';
      }

      return 'u--m__r__xs i-verified u--text--success';
    }

    get instagramSettingsLink() {
      if (this.activePageId) {
        return "https://www.facebook.com/".concat(this.nameOfPage, "-").concat(this.activePageId, "/settings/?tab=instagram_management&ref=page_edit");
      }

      return null;
    }

    dismissContactUs() {
      this.close();
      this.segment.track('canceled-contact-us-creds-wiz', {
        social_profile: this.socialProfile,
        page_name: this.source
      });
    }

    resetState() {
      this.state.setProperties({
        activePage: null,
        isAdminOfPage: null,
        isCorrectPage: null,
        nameOfPage: null,
        currentModal: 'credentialsStatus'
      });
    }
    /**
     * Take the response of the instagram business `getConnectedPages` call and setup the next step in the wizard
     *
     * @method beginRefresh
     * @param {Object} Response
     *
     */


    beginRefresh(args) {
      const {
        connectedPages,
        pages,
        authResponse,
        facebookUser
      } = args;
      const sortedPages = pages ? pages.sort((a, b) => a.name.localeCompare(b.name)) : [];
      this.setProperties({
        connectedPages,
        pages: sortedPages,
        authResponse,
        facebookUser
      });

      if (connectedPages && connectedPages.length) {
        this.set('currentModal', 'currentConnection');
        const connectedPage = connectedPages.firstObject;

        this._selectPage(connectedPage);

        this.setProperties({
          connectedPage: _object.default.create(connectedPage)
        });

        if (connectedPages.length > 1) {
          this.errors.log('Graph API is returning more than 1 connected page', args, 'critical');
          this.segment.track('more-than-one-connected-page-creds-wiz', {
            social_profile: this.socialProfile,
            connected_pages: JSON.stringify(connectedPages),
            page: this.credentials.source
          });
        }
      } else {
        this.set('currentModal', 'unconnectedPages');
      }
    }

    selectPage(page) {
      if ((0, _utils.isEqual)(this.activePageId, page.id)) {
        this._selectPage(null);
      } else {
        this._selectPage(page);
      }
    }

    selectPageNotFound() {
      this.set('state.nameOfPage', null);

      if (this.missingPage) {
        this.set('state.activePage', null);
      } else {
        this.set('state.activePage', {
          id: 0,
          name: null
        });
      }
    }

    _selectPage(page) {
      this.set('state.activePage', page);

      if (page && page.name) {
        this.set('state.nameOfPage', page.name);
      } else {
        this.set('state.nameOfPage', null);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "facebook", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "currentModal", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "missingPage", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showConnection", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showConnectionFailure", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showCredentialsStatus", [_dec9], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showDocsForNewPage", [_dec10], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "showFindNewPage", [_dec11], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "showGrantNewPermissions", [_dec12], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "showUnconnectedPages", [_dec13], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "showMissingPermissions", [_dec14], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "activePageId", [_dec15], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "activePageName", [_dec16], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "businessAccountId", [_dec17], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "hasUnconnectedProfessional", [_dec18], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "connectedPageId", [_dec19], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "currentGroup", [_dec20], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "isDisconnected", [_dec21], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "isExpiring", [_dec22], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "nameOfPage", [_dec23], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "nickname", [_dec24], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "owner", [_dec25], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "activePageEqualsGivenPage", [_dec26], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "featureStatusCss", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "featureStatusCss"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "instagramSettingsLink", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "instagramSettingsLink"), _class.prototype), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "refreshBusiness", [_dec29], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "checkAllScopes", [_dec30], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "dismissContactUs", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissContactUs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetState", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "beginRefresh", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "beginRefresh"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectPageNotFound", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPageNotFound"), _class.prototype), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "revokePermissions", [_dec31], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  _exports.default = IgBusinessSetup;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, IgBusinessSetup);
});